export default "__VITE_ASSET__CHLhOGDf__"